import React from 'react';
import Loading from '../Loading';

import styles from './styles';

const LoadingOverlay = ({visible}) => {
  return  visible ? (
    <div style={styles.wrapper}>
      <Loading/>
    </div>
  ) : null;
};

export default LoadingOverlay;



// WEBPACK FOOTER //
// ./src/components/Common/LoadingOverlay/index.js